import { Check, X } from "lucide-react";
import useTranslation from "../../client/hooks/useTranslation";

export interface ComparisonColumn {
  name: string;
  highlight?: boolean;
  // values[i] corresponds to criteria[i]: boolean OR a custom string (e.g. price)
  values: (boolean | string)[];
}

export default function ComparisonTable({ columns }: { columns: ComparisonColumn[] }) {
  const t = useTranslation();
  const criteria = t.marketing.common.criteria;
  return (
    <section className="px-6 py-12 lg:px-8">
      <div className="mx-auto max-w-5xl overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr>
              <th className="sticky left-0 bg-background p-3 text-left font-semibold text-foreground" />
              {columns.map((c) => (
                <th
                  key={c.name}
                  className={
                    "p-3 text-center font-semibold " +
                    (c.highlight ? "text-primary" : "text-foreground")
                  }
                >
                  {c.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {criteria.map((crit, rowIdx) => (
              <tr key={crit} className="border-t border-border">
                <td className="sticky left-0 bg-background p-3 text-left text-muted-foreground">
                  {crit}
                </td>
                {columns.map((c) => {
                  const v = c.values[rowIdx];
                  return (
                    <td
                      key={c.name}
                      className={"p-3 text-center " + (c.highlight ? "bg-primary/5" : "")}
                    >
                      {typeof v === "string" ? (
                        <span className="font-mono text-foreground">{v}</span>
                      ) : v ? (
                        <Check className="mx-auto h-5 w-5 text-primary" aria-label={t.marketing.common.yes} />
                      ) : (
                        <X className="mx-auto h-5 w-5 text-muted-foreground/50" aria-label={t.marketing.common.no} />
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
